import { apiInterfaceForJson, apiInterfaceForFormData } from "../common/apiManager";

const AI_TIMEOUT = 180000;

export const listMailboxes = () => apiInterfaceForJson("/mail/v1/mailboxes", "GET");
export const createMailbox = (data) => apiInterfaceForJson("/mail/v1/mailboxes", "POST", data);
export const updateMailbox = (id, data) => apiInterfaceForJson(`/mail/v1/mailboxes/${id}`, "PUT", data);
export const deleteMailbox = (id) => apiInterfaceForJson(`/mail/v1/mailboxes/${id}`, "DELETE");
export const setDefaultMailbox = (id) => apiInterfaceForJson(`/mail/v1/mailboxes/${id}/default`, "POST");
export const testMailboxSmtp = (id) => apiInterfaceForJson(`/mail/v1/mailboxes/${id}/test-smtp`, "POST");
export const testMailboxImap = (id) => apiInterfaceForJson(`/mail/v1/mailboxes/${id}/test-imap`, "POST");
export const testRawSmtp = (data) => apiInterfaceForJson("/mail/v1/mailboxes/test-smtp", "POST", data);
export const testRawImap = (data) => apiInterfaceForJson("/mail/v1/mailboxes/test-imap", "POST", data);
export const syncMailbox = (id) => apiInterfaceForJson(`/mail/v1/mailboxes/${id}/sync`, "POST", {}, undefined, 120000);

export const listMailTemplates = () => apiInterfaceForJson("/mail/v1/templates", "GET");
export const createMailTemplate = (data) => apiInterfaceForJson("/mail/v1/templates", "POST", data);
export const updateMailTemplate = (id, data) => apiInterfaceForJson(`/mail/v1/templates/${id}`, "PUT", data);
export const deleteMailTemplate = (id) => apiInterfaceForJson(`/mail/v1/templates/${id}`, "DELETE");

export const listMessages = (params = {}) => {
    const q = new URLSearchParams(
        Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null))
    ).toString();
    return apiInterfaceForJson(`/mail/v1/messages${q ? `?${q}` : ""}`, "GET");
};
export const getMessage = (id) => apiInterfaceForJson(`/mail/v1/messages/${id}`, "GET");
export const getThread = (id) => apiInterfaceForJson(`/mail/v1/messages/${id}/thread`, "GET");
export const sendMessage = (data) => apiInterfaceForJson("/mail/v1/messages/send", "POST", data);
export const saveDraft = (data) => apiInterfaceForJson("/mail/v1/messages/draft", "POST", data);
export const updateMessage = (id, data) => apiInterfaceForJson(`/mail/v1/messages/${id}`, "PUT", data);
export const cancelMessage = (id) => apiInterfaceForJson(`/mail/v1/messages/${id}/cancel`, "POST");
export const retryMessage = (id) => apiInterfaceForJson(`/mail/v1/messages/${id}/retry`, "POST");
export const markRead = (id, read = true) => apiInterfaceForJson(`/mail/v1/messages/${id}/read`, "POST", { read });
export const trashMessage = (id) => apiInterfaceForJson(`/mail/v1/messages/${id}/trash`, "POST");
export const unreadCount = () => apiInterfaceForJson("/mail/v1/unread-count", "GET");

export const leadMailThread = (leadId) => apiInterfaceForJson(`/mail/v1/lead/${leadId}/thread`, "GET");
export const recentLeadMail = (leadId) => apiInterfaceForJson(`/mail/v1/lead/${leadId}/recent`, "GET");

export const aiMailDraft = (data) =>
    apiInterfaceForJson("/mail/v1/ai/draft", "POST", data, undefined, AI_TIMEOUT);

export const listMailLibrary = () => apiInterfaceForJson("/mail/v1/library", "GET");
export const addMailLibrary = (formData) => apiInterfaceForFormData("/mail/v1/library", "POST", formData);
export const deleteMailLibrary = (id) => apiInterfaceForJson(`/mail/v1/library/${id}`, "DELETE");
export const uploadMailFile = (formData) => apiInterfaceForFormData("/mail/v1/upload", "POST", formData);

export function mergeMailVars(template, lead = {}) {
    if (!template) return "";
    const vars = {
        firstName: lead.firstName || "",
        lastName: lead.lastName || "",
        phone: lead.phone || "",
        email: lead.email || "",
        country: lead.country || "",
        city: lead.city || "",
        source: lead.source || "",
        status: lead.status || ""
    };
    return String(template).replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_, key) =>
        vars[key] === undefined || vars[key] === null ? "" : String(vars[key])
    );
}
